import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { Route } from "../../../node_modules/@slyte/router/index.js";
let CheckboxComp;

class Checkbox extends Route {
  render() {
    return { outlet: '#zcatcomponent', component: CheckboxComp };
  }

  static actions(arg1) {
    return Object.assign(super.actions({}), arg1);
  }

  _() {
    _;
  }

  getRequirements() {
    arguments[1].push(import(
      /* webpackChunkName: "components/javascript/lyte-components/checkbox-comp" */
      "../../../components/javascript/lyte-components/checkbox-comp"
    ).then(function(res) {
      CheckboxComp = res.CheckboxComp;
    }));

    
;
  }
}

export { Checkbox };
